// VEC-3421: sentinels del filtro `ticketTipo` de la grilla de Tickets cuando mtek.habilitado='true'.
// Con M Tek habilitado, los "predictivos" son correctivos con detalle=PREDICTIVO (ver
// TicketsRepository::getGridStatistics), así que las cards y el select de filtros de
// TicketCards.jsx / TicketGridFilters.jsx emiten estos valores en vez de 'PREDICTIVO'/'CORRECTIVO'
// para que el click/filtro traiga exactamente el mismo conjunto de tickets que cuenta la card.
// Reconocidos en el backend por TicketsService::queryFilters(), TicketGridNew::scopeUserSelectedFilters()
// y TicketsRepository::grid() (constantes Ticket::FILTRO_PREDICTIVO_MTEK / Ticket::FILTRO_CORRECTIVO_SIN_MTEK).
// No hay forma de compartir la constante entre PHP y JS: el valor debe mantenerse igual a mano en ambos lados.
export const TICKET_FILTRO_PREDICTIVO_MTEK = 'PREDICTIVO_MTEK';
export const TICKET_FILTRO_CORRECTIVO_SIN_MTEK = 'CORRECTIVO_SIN_MTEK';
